import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'


import { StyledButton, TextButton } from '../Home/StyledButton'
import SignIn from './SignIn'
import SignUp from './SignUp'

const Wrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9;
  background: rgba(0,0,0,0.5);
`

const ModalWrapper = styled.div`
  background-color: white;
  border-radius: 3px;
  width: 25rem;
  padding: 2.5rem;
  overflow: hidden;

  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  text-align: center;
`

class Modal extends React.Component {

  state = {which: 'SignIn'}

  switchState = (e) => {
    this.setState({
      which: this.state.which === 'SignIn' ? 'SignUp' : 'SignIn'
    })
  }

  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <Wrap>
        <ModalWrapper>
          { this.state.which === 'SignIn' ? <SignIn switchState={this.switchState} /> : <SignUp switchState={this.switchState} /> }
          <TextButton onClick={this.props.onClose} variation="darkgray">Cancel the Sign In</TextButton>
        </ModalWrapper>
      </Wrap>
    )
  }
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/index.js